/** «В работе» — ровно то, что отдаёт `GET /api/leads/in-work`. */
import { apiFetch, query } from "@/lib/api";

export type InWorkOutcome =
  | "replied"
  | "button"
  | "read"
  | "delivered"
  | "sent"
  | "failed"
  | "queued"
  | "none";

/** Галочки последнего нашего сообщения номеру: вебхук Wazzup, иначе снимок Messenger Viewer. */
export type WaTick = "read" | "delivered" | "sent" | "error";

export type InWorkLead = {
  lead_id: number;
  created: string;
  source: string;
  responsible: string;
  next_work: string | null;
};

export type InWorkCall = {
  id: number;
  at: string;
  dur: number;
  /** Код 200 — соединились; это ещё НЕ разговор. */
  connected: boolean;
  code: string;
  /** Разметка по расшифровке: talk — разговор, none — не было, unclear — не понять, "" — не размечен. */
  talk: string;
  reason: string;
  line: string;
  text: string;
};

/** Строка вкладки — уникальный номер: у номера бывает несколько лидов. */
export type InWorkPhone = {
  phone: number;
  /** Лиды номера в работе, свежий первым. */
  leads: InWorkLead[];
  /** Создание самого свежего лида номера. */
  created: string;
  /** Рассылка «Лид 1» по номеру: очередь CRM (кат. 49) и/или сам шаблон в Wazzup. */
  mailing: {
    stage: "queued" | "sent" | "cancelled" | "failed" | "none";
    status: string;
    queued: string | null;
    sent: string | null;
    count: number;
    in_crm: boolean;
    in_wazzup: boolean;
    tick: WaTick | null;
  } | null;
  button: string | null;
  replied: string | null;
  crm_in: number;
  crm_out: number;
  outcome: InWorkOutcome;
  wa: {
    state: WaTick;
    at: string | null;
    /** Текст ошибки Wazzup для красной галочки. */
    detail: string;
    source: "webhook" | "viewer";
    /** Клиент не писал, ничего не доставлено, последнее — красная или одна галочка > 1 ч. */
    unreachable: boolean;
  } | null;
  /** Звонки номера с первого лида: входящий, создавший лид; наши исходящие; лучший разговор. */
  calls: {
    first_in: InWorkCall | null;
    in: number;
    out: number;
    out_connected: number;
    talks: number;
    best: InWorkCall | null;
  } | null;
};

export type LeadsInWork = {
  days: number;
  since: string;
  /** С какого момента пишет наш вебхук Wazzup: до него доставки/прочтения/кнопок нет. */
  webhook_since: string | null;
  /** Уникальных номеров. */
  total: number;
  leads_total: number;
  /** Лиды без российского номера — в список не входят. */
  no_phone: number;
  /** Номеров, которым была рассылка «Лид 1». */
  mailed: number;
  outcomes: Record<InWorkOutcome, number>;
  wa: Record<WaTick | "none", number>;
  unreachable: number;
  /** Галочки рассылки «Лид 1» по номерам: sent — одна, error — красная, delivered — не прочитал. */
  mailing_ticks: Record<WaTick | "unknown", number>;
  phones: InWorkPhone[];
};

export function loadLeadsInWork(days: number): Promise<LeadsInWork> {
  return apiFetch<LeadsInWork>(`/api/leads/in-work${query({ days: String(days) })}`);
}
